import { render, staticRenderFns } from "./UserContent.vue?vue&type=template&id=1f6e70c4"
import script from "./UserContent.vue?vue&type=script&lang=js"
export * from "./UserContent.vue?vue&type=script&lang=js"
import style0 from "./UserContent.vue?vue&type=style&index=0&id=1f6e70c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports